import { render, staticRenderFns } from "./HXSteps.vue?vue&type=template&id=47f54c4f&scoped=true"
import script from "./HXSteps.vue?vue&type=script&lang=js"
export * from "./HXSteps.vue?vue&type=script&lang=js"
import style0 from "./HXSteps.vue?vue&type=style&index=0&id=47f54c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f54c4f",
  null
  
)

export default component.exports